interface EnvironmentType {
  primariaGraphQLURL: string;
  secundariaGraphQLURL: string;
  urlImages: string;
  urlVideos: string;
}

export const environment: EnvironmentType = {
  primariaGraphQLURL: process.env.REACT_APP_GRAPHQL_URL_PRIMARIA || "",
  secundariaGraphQLURL: process.env.REACT_APP_GRAPHQL_URL_SECUNDARIA || "",
  urlImages: process.env.REACT_APP_URL_IMAGES || "",
  urlVideos: process.env.REACT_APP_URL_VIDEOS || "",
};
